import axios from 'axios';
import { AppSalesOrder } from '../models/AppSalesOrder';

const API_URL = process.env.REACT_APP_SERVER_URL + "/app/salesorders";

export const AppSalesOrderService = {
    getAllSalesOrders: async (): Promise<AppSalesOrder[]> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.get(`${API_URL}/getAllSalesOrders`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    getSalesOrderById: async (id: number): Promise<AppSalesOrder> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.get(`${API_URL}/getSalesOrderById/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    getSalesOrderByWarehouseId: async (warehouseId: string): Promise<AppSalesOrder[]> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.get(`${API_URL}/getAllSalesOrdersByWarehouseId/${warehouseId}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    getSalesOrdersPaginated: async (
        page: number,
        limit: number,
        search?: string,
        warehouseId?: string | number
    ): Promise<{ orders: AppSalesOrder[]; total: number }> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const params: Record<string, any> = { page, limit };
        if (search) params.search = search;
        if (warehouseId !== undefined && warehouseId !== null && warehouseId !== '') params.warehouseId = warehouseId;
        const response = await axios.get(`${API_URL}/getSalesOrdersPaginated`, {
            params,
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    createSalesOrder: async (salesOrder: Omit<AppSalesOrder, 'id' | 'created_time' | 'updated_time'>): Promise<AppSalesOrder> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.post(`${API_URL}/add`, salesOrder, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    updateSalesOrder: async (id: number, salesOrder: Omit<AppSalesOrder, 'id' | 'created_time' | 'updated_time'>): Promise<AppSalesOrder> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        const response = await axios.put(`${API_URL}/update/${id}`, salesOrder, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    deleteSalesOrder: async (id: number): Promise<void> => {
        const token = localStorage.getItem('gpcwstoken_kw');
        await axios.delete(`${API_URL}/delete/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    }
};
